<form [formGroup]="form" [attr.autocomplete]="'off'">
  <div class="form-row">
    <mat-form-field appearance="outline">
      <mat-label>Partner</mat-label>
      <input
        type="text"
        placeholder="Vælg partner"
        aria-label="Partner"
        matInput
        #partnerInput
        [formControl]="partnerCtrl"
        [matAutocomplete]="auto"
        (blur)="onBlur()"
        />
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="partnerSelected($event)">
          @for (partner of filteredPartners | async; track partner) {
            <mat-option [value]="partner">
              {{ partner.name }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </form>
